import {
  APP_LOAD,
  TICK,
  CLIENT_LOGIN,
  LOGOUT,
  REDIRECT,
  LOGOUT_PUBREG,
  FAILED
} from '../constants/actionTypes';

const invalidMessage = "Invalid Email or Password";

const defaultState = {
  token: null,
  clientToken: null,
  artistToken: null,
  appName: 'Checkin APP'
}

const common = (state = defaultState, action) => {
  switch (action.type) {
    case APP_LOAD:

      return {
        ...state, 
        appLoaded: true,
        clientToken: action.clientToken || null,
        artistToken: action.artistInfo && (action.artistInfo.client || action.artistInfo.meta),
        artistInfo: action.artistInfo ? action.artistInfo.artist : null,
      }

    case CLIENT_LOGIN:
      return {
        clientToken: action.error ? null : action.payload,
        redirectTo: action.error ? null : '/projects'
      }

    case 'REGISTER_ARTIST':
      return {
        artistInfo: action.payload.artist
      }

    case 'ARTIST_LOGIN':
      return {
        ...state,
        // artistInfo: action.error && action.payload.artist,
        errors: action.error && invalidMessage,
        artistInfo: action.payload.artist && action.payload.artist,
        roles: action.payload.roles,
        redirectTo: !action.error && '/artist/dashboard'
      }
    case FAILED:
      const token = new URLSearchParams(location.search).get('token');
      if (token) {
        return {
          redirectTo: '/public_registration?token=' + token
        }
      }
    case LOGOUT:
      const location = new URL(window.location.href);
      const publicToken = new URLSearchParams(location.search).get('token');
      window.localStorage.clear()
      if (publicToken) {
        return {
          redirectTo: '/public_registration?token=' + publicToken
        }
      }
      return {
        redirectTo: '/',
        token: null
      }
    case LOGOUT_PUBREG:
      return {
        redirectTo: '/artist/login',
        token: null
      }
    case REDIRECT:
      return {
        ...state,
        redirectTo: null
      }

    case 'SET_ARTIST':
      return {
        ...state,
        artistInfo: action.payload.artist
      }

    case 'PUBLIC_ARTIST_LOGIN':
      return {
        ...state,
        errors: action.error && invalidMessage,
        partialArtist: null,
        publicArtist: action.payload,
        artistInfo: action.payload.artist
      }
    case 'PARTIAL_ARTIST_LOGIN':
      return {
        ...state,
        partialArtist: action.payload.artist,
        artistInfo: action.payload.artist
      }
    default:
      return state;
  }
};


export default common



// WEBPACK FOOTER //
// ./src/reducers/common.js